<script setup>
defineProps({
  lineItem: {
    type: Object,
    required: true
  },
  canvasImage: {
    type: String,
    default: null
  },
  shouldShowBrand: {
    type: Boolean,
    required: true
  }
});

const formatPrintSize = size => `${size.width}" x ${size.height}"`;
</script>

<template>
  <div class="product-details__product">
    <div class="product-details__product-column product-details__product-column--image">
      <img
        :alt="lineItem.productName || lineItem.name"
        :src="canvasImage || lineItem.productImage"
        class="product-details__product-image"
      />
    </div>

    <div class="product-details__product-column product-details__product-column--data">
      <h3 class="product-details__product-name">{{ lineItem.productName }}</h3>

      <ul class="product-details__product-details">
        <li class="product-details__product-details-item">
          <span class="product-details__product-details-title">Color:</span>
          <span class="product-details__product-details-data">
            {{ lineItem.productColor }}
          </span>
        </li>

        <li
          v-for="size in lineItem.printSizes"
          :key="size.position"
          class="product-details__product-details-item"
        >
          <span class="product-details__product-details-title">{{ size.position }}:</span>
          <span class="product-details__product-details-data">
            {{ formatPrintSize(size) }}
          </span>
        </li>
      </ul>
    </div>

    <div
      v-if="shouldShowBrand"
      class="product-details__product-column product-details__product-column--brand"
    >
      <img
        :alt="lineItem.brand.name"
        :src="lineItem.brand.logo"
        class="product-details__product-brand"
      />
      <div class="product-details__product-style">
        {{ lineItem.productStyle }}
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.product-details {
  &__product {
    display: grid;
    grid-template-columns: 64px 1fr auto;
    gap: 12px;
    margin-bottom: 16px;

    @include with-tablet {
      grid-template-columns: 116px 1fr auto;
      gap: 16px;
    }
  }

  &__product-column {
    &--image {
      width: 100%;
      border-radius: 4px;
    }

    &--brand {
      text-align: right;
    }
  }

  &__product-brand {
    display: block;
    max-width: 62px;
    margin-bottom: 4px;
  }

  &__product-style {
    color: $warm-grey;
    font-size: 12px;
  }

  &__product-image {
    width: 100%;
    border-radius: 4px;
  }

  &__product-name {
    margin: 0 0 6px;
    color: $black;
    font-size: 14px;
    line-height: 16px;

    @include with-tablet {
      margin-bottom: 15px;
      font-size: 16px;
    }
  }

  &__product-details-item {
    font-size: 14px;

    @include with-tablet {
      margin-bottom: 5px;
    }
  }

  &__product-details-title {
    margin-right: 4px;
    color: $warm-grey;
    font-weight: 400;
  }

  &__product-details-data {
    color: $text-black;
    font-weight: 700;
  }
}
</style>
